import moment from "moment";

const TOCK_BUSINESS = "auburnroadvineyards";

export const TOCK_RESERVATIONS_URL = `https://www.exploretock.com/${TOCK_BUSINESS}/`;

/**
 * Build a Tock search URL. `date` can be a moment, Date, or YYYY-MM-DD string.
 */
export const tockSearchUrl = (partySize = 2, date) => {
  const day = date ? moment(date) : moment();
  return `https://www.exploretock.com/${TOCK_BUSINESS}/search?date=${day.format(
    "YYYY-MM-DD"
  )}&size=${partySize}`;
};
